"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var financeSummaryBlocksStaticContentStyles = styles_1.makeStyles(function (_a) {
    var typography = _a.typography, palette = _a.palette;
    return ({
        emphasizedText: {
            padding: '0 0 0 12px',
            fontFamily: typography.fontFamily2,
            color: palette.common.black,
            paddingBottom: '20px',
        },
    });
}, { name: 'Summary_FinanceSummaryBlocksStaticContent' });
exports.default = financeSummaryBlocksStaticContentStyles;
